/* eslint-disable */
const sampleModule = {
  sampleEndpoint: 'restapi_endpoint',
};

const jobs = {
  recruiters: '/jobs/recruiters',
  filterJobs: '/jobs/filters',
  createJob: '/jobs/save',
  updateJobStatus: '/jobs/updateJobStatus',
  editJob: '/jobs/editJob/',
  shareInternalLink: '/jobs/shareInternalLink',
  updateDescription: '/jobs/updateDescription',
  updateComments: '/jobs/updateComments',
  updateSkills: '/jobs/updateSkills',
  updateJobDetails: '/jobs/updateJobDetails',
  updateOthersTab: '/jobs/updateOthersTab',
  fetchJobDetails: '/jobs/fetchJobDetails/',
  updateJobLocation: '/jobs/updateJobLocation',
  updateJobRecruiters: '/jobs/updateJobRecruiters',
  addJobNotes: '/jobs/addNotes',
  updateJobNotes: '/jobs/updateNotes/',
  checkDuplicateJobId: '/jobs/checkDuplicateJobId',
  getResumeSearchString: '/dice/booleanSearch/',
}

const viewJob = {
  getAllCandidatesForJob: '/viewJob/all/',
  getCandidatesOfRecruiter: 'viewJob/',
  updateCandidateStatus: '/viewJob/updateCandidateStatus',
  updatePlacedWithMroads: '/viewJob/placedWithMroads',
  getMatchingResumes: '/viewJob/getMatchingResumes/',
  updateCandidateComments: '/viewJob/updateAtsCandidateComments',
}

const common = {
  locations: '/common/fetchLocations',
  skills: '/common/fetchSkills',
  jobIds: '/common/getJobIds',
  activeJobIds: '/common/getActiveJobIds',
  consultancies: '/common/consultancies',
  statuses: '/common/status',
  mailTemplateList: '/common/mailTemplates',
  getMailTemplate: '/common/getMailTemplate',
  sendEmail: '/common/sendMail',
  sources: '/common/fetchSource',
  getMailMergeTemplate: '/common/getMailMergeTemplate/',
  preferredJobLocations: '/common/jobLocations/',
  getJobByOrgId: '/common/fetchWebsiteJobs/',
  getJobDetailsByJobOrderId: '/common/fetchWebsiteBy/',
  saveAudio: '/common/saveAudio',
  diceJob: '/common/diceJob',
  fetchLocations: '/common/fetchByPropertiesType/location',
  fetchSkills: '/common/fetchByPropertiesType/skills',
  fetchJobTitles: '/common/fetchByPropertiesType/title',
  addATSProperty: '/common/addATSProperties',
  updateATSProperties: '/common/updateATSProperties',
  deleteATSProperties: '/common/deleteATSProperties/',
}

const interviews = {
  getCurrentInterviews: '/interviews/currentInterviews',
  getCompletedInterviews: '/interviews/completedInterviews',
  schedulePanna: '/interviews/schedulePanna',
  scheduleLive: '/interviews/scheduleLive',
  updateInterviewStatus: '/interviews/updateInterviewStatus',
}

const talentpool = {
  candidateProfiles: '/talentPool/filters',
  bookmark: '/talentPool/updateBookMark',
  bookmarkRecords: '/talentPool/getBookMarkCandidates',

  applyJob: '/talentPool/applyJob',
  shareCandidateProfiles: '/talentPool/shareCandidateProfiles',
  bulkMail: '/talentPool/sendBulkMail',
}

const postJob = {
  postJobOnWebSite: '/postJob/postJobOnWebSite/',
  getInterviewPositions: '/postJob/getInterviewPositions',
  updateInterviewPosition: '/postJob/updateInterviewPositionId',
};

const candidateProfile = {
  fetchCandidateInfo: 'candidate/',
  updateProfileInfo: 'candidate/update/',
  getCandidateDocuments: 'documents/',
  getAllPayTypes: 'common/payType',
  fetchAppliedJobs: 'candidate/appliedJobs/',
  getCandidateJobHistory: 'candidate/jobHistory',
  getAllJobStatuses: 'jobStatus',
  updateJobStatus: 'candidate/updateStatusComments',
  getAllJobTypes: 'candidate/candidateTitles',
  getAllWorkAuthorizations: 'common/workAuthorization',
  getAllResumeSources: 'common/fetchSource',
  updateResume: 'candidate/updateResume',
  fetchCandidateResumeDetails: 'candidate/resume/'
};

const signatureForm = {
  getSignatureForm: 'signature/',
  submitFeedback: '/signature/reject',
  submitSignature: '/signature/submit',
}

const documents = {
  uploadDocument: 'documents/upload/',
}

const interviewSlots = {
  monthSlots: '/interviewslots/monthSlots',
  createInterviewSlots: '/interviewslots/create',
  deleteInterviewSlots: '/interviewslots/',
  getAllSlots: '/interviewslots/all',
  rescheduleInterviewSlot: '/interviewslots/reschedule',
  getDaySlots: '/interviewslots/daySlots',
}

const resumeParser = {
  resumeParse: '/commonservices/api/resume-upload-parse-service',
  checkEmailDuplicate: 'candidate/checkDuplicate/',
  onCandidateDetailsSave: 'candidate/add',
  jdMatchScore: 'common/jdMatchScore',
  updateSkills: 'NewSkills_calculation',
}

const candidate = {
  candidateApply: '/candidate/apply',

}

const terms = {
  fetchOrgTermsById: '/terms/',
}

const consultancy = {
  getConsultancyOptions: '/consultancy/consultancyDetails',
  getConsultancyById: '/consultancy/'
}

const dice = {
  searchProfiles: '/dice/profileSearch',
  viewProfile: '/dice/profileView',
  diceDashboard: '/dice/dashboard',
  atsViewProfile: '/dice/updateATSViewFromDice',
}

const ats = {
  atsDashboard: '/dashboard',
}

export {
  candidate,
  sampleModule,
  candidateProfile,
  documents,
  common,
  jobs,
  viewJob,
  talentpool,
  interviews,
  postJob,
  signatureForm,
  interviewSlots,
  resumeParser,
  terms,
  consultancy,
  dice,
  ats,
};
